import React from "react";

import useIsSandboxMode from "customHooks/useIsSandboxMode";

function isSandboxModeHOC(WrappedComponent) {
  return (props) => {
    const isSandboxMode = useIsSandboxMode();

    return <WrappedComponent isSandboxMode={isSandboxMode} {...props} />;
  };
}

export default isSandboxModeHOC;
